import { ReportConfig } from './sparepart-report.config';
import { PERMISSIONS } from '@core/constants/permissions.constants';

export const BACK_JOB_REPORT_CONFIG: ReportConfig = {
  id: 'back-job',
  title: 'Back Job Report',
  permissions: {
    view: PERMISSIONS.GSE.REPORTS.BACKJOB.VIEW,
    export: PERMISSIONS.GSE.REPORTS.BACKJOB.EXPORT,
  },
  filters: [
    {
      type: 'text',
      field: 'search',
      label: 'Search',
      placeholder: 'Search',
    },
    {
      type: 'date-range',
      field: 'dateRange',
      label: 'Date Range',
      placeholder: 'Date range',
    },
    {
      type: 'dropdown',
      field: 'equipment',
      label: 'Equipment',
      placeholder: 'Equipment',
    },
    {
      type: 'dropdown',
      field: 'backJobStatus',
      label: 'Status',
      placeholder: 'Status',
    },
  ],

  columns: [
    {
      field: 'jobCardId',
      header: 'Job Card ID',
      type: 'text',
      width: '12%',
    },
    {
      field: 'equipment',
      header: 'Equipment Name',
      type: 'text',
      width: '20%',
    },
    {
      field: 'backJobCardId',
      header: 'Back Job Card ID',
      type: 'text',
      width: '14%',
    },
    {
      field: 'status',
      header: 'Status',
      type: 'text',
      pipes: ['replaceUnderscore', 'titlecase'],
      width: '12%',
    },
    {
      field: 'reason',
      header: 'Reason',
      type: 'text',
      width: '42%',
    },
  ],
};
